import JEQuestions from "./questions";
export default JEQuestions;
